<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'evaluation-share.dialog-title'">
    </span>
  </div>
  <wizard-steps [steps]="evaluationShare.steps"
    [state]="evaluationShare.stepState">
  </wizard-steps>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info">
      {{evaluationShare.stepInfo }}</p>
    <div class="common-modal__form-container">
      @if(evaluationShare.stepState === 1){
        @if (evaluationShare.contactsField) {
          <field-type-contacts
            [field]="evaluationShare.contactsField"
            [valueId]="evaluation.evaluationId"
            (sendContacts)="getSelectContacts($event)"
            (contactsClosed)="evaluationShare.contactsOpen = !evaluationShare.contactsOpen">
          </field-type-contacts>
        }
        @if (!evaluationShare.contactsOpen) {
          <field-type-rich-text-editable
            [field]="evaluationShare.commentsField"
            [preSelectItem]="evaluationShare.comments"
            (itemSelected)="itemSelectedOn($event)">
          </field-type-rich-text-editable>
        }
        <field-type-switch [field]="{label: 'evaluation-share.share-documents'|afTranslate}"
          [preSelectItem]="evaluationShare.shareDocuments"
          [disabled]="evaluationShare.hasConfidential"
          [small]="true"
          (itemSelected)="evaluationShare.shareDocuments = $event.newValue"></field-type-switch>
      }@else {
        <upload-documents [type]="'evaluationShare'"
          [files]="evaluationShare.documents"
          [documentationList]="evaluationShare.documentationList"
          [component]="evaluationShare.uploadComponent"
          (uploadDocumentsEmit)="uploadDocumentsOn($event)">
        </upload-documents>
      }
    </div>
  </div>
  @if(evaluationShare.hasConfidential && evaluationShare.showDocumentsWarning){
    <advice-message
      [type]="'warning'"
      [text]="evaluationShare.confidentialWarning"
      (closeAdvice)="evaluationShare.showDocumentsWarning = false">
    </advice-message>
  }

  <div class="common-modal__footer">
    <button class="common-button__text-border"
      [ngClass]="evaluationShare.stepState === 1?'common-button__text-border': 'common-button__text-noborder'"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">
        _Cancelar
      </span>
    </button>
    @if(evaluationShare.stepState === 1){
      <button class="common-button__text"
        (click)="goNext()">
        <span class="common-button__text-title"
          [afTranslate]="'common.next'">
          _siguiente
        </span>
      </button>
    }@else {
      <button class="common-button__text-border"
        (click)="goBack()">
        <span class="common-button__text-title"
          [afTranslate]="'common.previous'">
          _Anterior
        </span>
      </button>
      <button class="common-button__text"
        (click)="finishOption()">
        <span class="common-button__text-title"
          [afTranslate]="'common.share'">
          _compartir
        </span>
      </button>
    }

  </div>
</div>
